module.exports = __webpack_public_path__ + "img/ico-success-error.6b56a772.svg";